import { createSelector, Selector } from 'reselect';
import { RootState } from '../../redux/root-reducer';
import { IUserLocationFromCloudFront } from '../../constants/types/configuration/userGlobalConfig.types';

export const userLocationSelector: Selector<RootState, IUserLocationFromCloudFront> = createSelector(
    (state: RootState) => state.configuration,
    config => config.userCurrentLocation,
);
